
@switch (sectionData.type) {
  @case (types.Carousel) {
    <content-list
      [content]="sectionData.observable"
      [type]="sectionData.contentListType"
      [head]="sectionData.title"
    ></content-list>
  }
  <!-- ACCORDION QA SECTION START -->
  @case (types.Accordion_QA) {
    <accordion-qa
      [entryClicked]="sectionData.entryClicked"
      [content]="sectionData.observable"
      [label]="sectionData.label"
      [labelFontSize]="sectionData.labelFontSize"
      [questionsAndAnswers]="sectionData?.questionsAndAnswers"
      [heroCarousel]="sectionData.heroCarousel"
      [autoExpandFirstEntry]="sectionData.autoExpandFirstEntry"
    ></accordion-qa>
  }
  <!-- ACCORDION QA SECTION END -->
  <!-- CONTRIBUTOR SECTION START -->
  @case (types.Contributors) {
    <app-contributor-grid-list [contributors]="sectionData.contributors">
    </app-contributor-grid-list>
  }
  <!-- CONTRIBUTOR SECTION END -->
  <!-- Variable COLUMN CONTAINER SECTION START -->
  @case (types.Variable_Column_Container) {
    <app-variable-column-container
      [columnEntries]="sectionData.columnEntries"
    ></app-variable-column-container>
  }
  <!-- Variable COLUMN CONTAINER SECTION END -->
  <!-- NAV WITH IMG CAROUSEL SECTION START -->
  @case (types.Nav_With_Image_Carousel) {
    <app-nav-with-image-carousel
      [navLinks]="sectionData.navEntries"
      [imagesWithInfo]="sectionData.imagesWithInfo"
    ></app-nav-with-image-carousel>
  }
  <!-- NAV WITH IMG CAROUSEL SECTION END -->
  <!-- TEXT LIST SECTION START -->
  @case (types.Bullet_List) {
    <app-text-list
      [listItems]="sectionData.entries"
      [listType]="'bullet'"
    ></app-text-list>
  }
  @case (types.Numbered_List) {
    <app-text-list
      [listItems]="sectionData.entries"
      [listType]="'number'"
    ></app-text-list>
  }
  <!-- TEXT LIST SECTION END -->
  <!-- VISUAL LINK SECTION START -->
  @case (types.Visual_Link) {
    <app-visual-link
      [imageUrl]="sectionData.imageUrl"
      [linkUrl]="sectionData.linkUrl"
      [linkText]="sectionData.linkText"
    ></app-visual-link>
  }
  <!-- VISUAL LINK SECTION END -->
  <!-- CALLOUT SECTION START -->
  @case (types.Callout) {
    <app-tick-callout
      [bodyText]="sectionData.body"
      [headerText]="sectionData.header"
    ></app-tick-callout>
  }
  <!-- CALLOUT SECTION END -->
  <!-- TICK QUOTE SECTION START -->
  @case (types.Tick_Quote) {
    <app-quote
      [quoteText]="sectionData.quoteText"
      [quoteSource]="sectionData.quoteSource"
      [quoteTitle]="sectionData.quoteTitle"
    ></app-quote>
  }
  <!-- TICK QUOTE SECTION END -->
  <!-- NAVIGATION DESTINATION SECTION START -->
  @case (types.Navigation_Destination) {
    <div [id]="sectionData.elementId" [ngClass]="{ height: '0px' }"></div>
  }
  <!-- NAVIGATION DESTINATION SECTION END -->
  <!-- LIFE CYCLE SECTION START -->
  @case (types.Image_Carousel) {
    <app-life-cycle-slider
      [items]="sectionData.imageDescriptions"
    ></app-life-cycle-slider>
  }
  <!-- LIFE CYCLE SECTION ENDS -->
  <!-- EXPLORER DASHBOARDS SECTION START -->
  @case (types.Explorer_Dashboards) {
    <content-list
      [content]="sectionData.observable"
      [type]="sectionData.contentListType"
      [head]="'Dashboards'"
    ></content-list>
  }
  <!-- EXPLORER DASHBOARDS SECTION END -->
  <!-- BODY SECTION START -->
  @case (types.Body) {
    <div
      class="body-section"
      [ngClass]="{
        collapsed: sectionData.collapsed && bodySectCollapseToggle,
        highlighted: sectionData.highlighted
      }"
      >
      @if (sectionData.title.length > 0) {
        <h2
          [innerHTML]="sectionData.title"
        ></h2>
      }
      <div [innerHTML]="sectionData.html"></div>
      @if (sectionData.collapsed) {
        <button
          mat-flat-button
          color="primary"
          (click)="toggleBodySectionCollapse()"
          >
          Show {{ bodySectCollapseToggle ? "More" : "Less" }}
        </button>
      }
    </div>
  }
  <!-- BODY SECTION END -->
  <!-- QUOTE SECTION START -->
  @case (types.Quote) {
    <div class="quote-section">
      <div class="text" [innerHTML]="sectionData.body"></div>
      <div class="author" [innerHTML]="sectionData.author"></div>
    </div>
  }
  <!-- QUOTE SECTION END -->
  <!-- REACTIONS SECTION START -->
  @case (types.Reactions) {
    <app-reactions></app-reactions>
  }
  <!-- REACTIONS SECTION END -->
  <!-- AUDIO CLIP SECTION START -->
  @case (types.Audio_Clip) {
    <div class="audio-clip-section">
      @if (sectionData.title.length > 0) {
        <h3>{{ sectionData.title }}</h3>
      }
      <div class="clip">
        <audio controls>
          <source [src]="sectionData.src" type="audio/mpeg" />
          Your browser does not support the audio element.
        </audio>
      </div>
      <button
        mat-flat-button
        color="primary"
        (click)="toggleAudioTranscriptCollapse()"
        >
        {{ audioTranscriptToggle ? "Show" : "Hide" }} Transcript
      </button>
      @if (!audioTranscriptToggle) {
        <div
          class="transcript"
          [innerHTML]="sectionData.transcript"
        ></div>
      }
    </div>
  }
  <!-- AUDIO CLIP SECTION END -->
  <!-- IFRAME SECTION START -->
  @case (types.Iframe) {
    @if (sectionData.title.length > 0) {
      <h3>{{ sectionData.title }}</h3>
    }
    <iframe
      [height]="sectionData.height"
      [src]="cleanIframeUrl"
      class="cp-iframe {{ sectionData.width }}"
    ></iframe>
  }
  <!-- IFRAME SECTION END -->
  <!-- SEARCHBAR SECTION START -->
  @case (types.Searchbar) {
    <app-searchbar></app-searchbar>
  }
  <!-- SEARCHBAR SECTION END -->
  <!-- CONTRIBUTOR HIGHLIGHT SECTION START -->
  @case (types.Contributor_Highlight) {
    <a [href]="getPersonLink(sectionData.person)" class="contributor-highlight">
      <h3>{{ sectionData.person.fullname }}</h3>
      <div [innerHTML]="sectionData.text"></div>
    </a>
  }
  <!-- CONTRIBUTOR HIGHLIGHT SECTION END -->
  <!-- VIDEO SECTION START -->
  @case (types.Video) {
    <div class="cp-video-container">
      <iframe
        class="video"
        [src]="sectionData.url"
        frameborder="0"
        allow="accelerometer; autoplay=0; rel=0; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
        >
      </iframe>
    </div>
  }
  <!-- VIDEO SECTION END -->
  <!-- VISUAL LINKS START -->
  @case (types.Visual_Links) {
    <div class="visual-links">
      @for (l of sectionData.links; track l) {
        <a
          class="link"
          [href]="l.url"
          [ngStyle]="getVisualLinkStyle(l)"
          >
          {{ l.text }}
        </a>
      }
    </div>
  }
  <!-- VISUAL LINKS END -->
  <!-- COLUMN SECTION START -->
  @case (types.Column) {
    @for (c of sectionData.sections; track c; let left = $first) {
      <app-custom-page-section
        class="column"
      [ngStyle]="
        getColumnStyle(
          left,
          sectionData.leftWidth,
          sectionData.leftOffset,
          sectionData.rightOffset
        )
      "
        [sectionData]="c"
      ></app-custom-page-section>
    }
  }
  <!-- COLUMN SECTION END -->
  <!-- TABS SECTION START -->
  @case (types.Tabs) {
    @if (sectionData.title.length > 0) {
      <h3
        class="tab-title"
        [innerHTML]="sectionData.title"
      ></h3>
    }
    <mat-tab-group mat-align-tabs="center" [(selectedIndex)]="tabindex">
      @for (t of sectionData?.tabs; track t) {
        <mat-tab>
          <ng-template mat-tab-label>
            @if (t?.icon.length > 0) {
              <img [src]="t?.icon" [alt]="t?.name" />
            }
            <span [innerHTML]="t?.name"></span>
          </ng-template>
          @for (c of t?.sections; track c) {
            <app-custom-page-section
              [sectionData]="c"
            ></app-custom-page-section>
          }
        </mat-tab>
      }
    </mat-tab-group>
  }
  <!-- TABS SECTION END -->
  <!-- CARDS SECTION START -->
  @case (types.Cards) {
    @if (sectionData.title.length > 0) {
      <h3 class="kx-cards-title">
        <span [innerHTML]="sectionData.title"></span>
      </h3>
    }
    <div class="kx-cards">
      @for (card of sectionData.cards; track card; let i = $index) {
        <div
          class="kx-card"
          [style.--featured-image]="getCssUrlVar(card.image)"
          [ngClass]="{
            active: activeCard == i,
            noActiveCards: activeCard == null
          }"
          (click)="activeCard != i ? (activeCard = i) : (activeCard = null)"
          >
          <h3 [innerHTML]="card.title"></h3>
          @if (card.subtitle && card.subtitle.length > 0) {
            <h4
              [innerHTML]="card.subtitle"
            ></h4>
          }
        </div>
        <div
          class="kx-card-body body-{{ i }}"
          [ngClass]="{ active: activeCard == i }"
          >
          @for (s of card?.sections; track s) {
            <app-custom-page-section
              [sectionData]="s"
            ></app-custom-page-section>
          }
        </div>
      }
    </div>
  }
  <!-- CARDS SECTION END -->
  <!-- RELATED CONTENT SECTION START -->
  @case (types.Related_Content) {
    <app-related-content
      [source]="sectionData.source.toLowerCase()"
      [parentTitle]="sectionData.parentTitle"
      [tags]="sectionData.tags"
    ></app-related-content>
  }
  <!-- RELATED CONTENT SECTION END -->
  <!-- INFOGRAPHIC SECTION START -->
  @case (types.Infographic) {
    @if (sectionData.title.length > 0) {
      <h3
        class="tab-title"
        [innerHTML]="sectionData.title"
      ></h3>
    }
    <app-image-map-infographic
      [id]="sectionData.id"
      displayType="modal"
    ></app-image-map-infographic>
  }
  <!-- INFOGRAPHIC SECTION SECTION END -->
  <!-- IMAGE SLIDER SECTION START -->
  @case (types.Image_Slider) {
    <swiper-container
      (swiperinit)="onSwiper($event)"
      class="custom-page-image-slider full-width"
      navigation="true"
      >
      @for (item of sectionData.items; track item) {
        <swiper-slide>
          <div class="image-slider-slide">
            @if (item.type == 'image') {
              <img
                [src]="item.src"
                [alt]="item.caption"
                />
            }
            @if (item.type == 'video') {
              <video [src]="item.src" controls></video>
            }
            @if (item.caption.length > 0) {
              <p [innerHTML]="item.caption"></p>
            }
          </div>
        </swiper-slide>
      }
    </swiper-container>
    <div class="pagination primary">
      @for (x of sectionData.images; track x; let i = $index) {
        <div
          class="indicator"
          [ngClass]="{ on: i == swiper?.activeIndex }"
          (click)="navigateTo(i)"
        ></div>
      }
    </div>
  }
  <!-- IMAGE SLIDER SECTION END -->
  @default {
    <p>Invalid Section!</p>
  }
}
